import { BaseFetch } from "../main-model"
export default class NumberPP3Model extends BaseFetch {
    getExportPP3CreditBy = (data) =>
        this.authFetch({
            url: "number-pp3/getExportPP3CreditBy",
            method: "POST",
            body: JSON.stringify(data),
        })
        getMaxReadAnalysis = (data) =>
        this.authFetch({
            url: "number-pp3/getMaxReadAnalysis",
            method: "POST",
            body: JSON.stringify(data),
        })
        
    getNumberPP3By = (data) =>
        this.authFetch({
            url: "number-pp3/getNumberPP3By",
            method: "POST",
            body: JSON.stringify(data),
        })
    getNumberPP3ById = (data) =>
        this.authFetch({
            url: "number-pp3/getNumberPP3ById",
            method: "POST",
            body: JSON.stringify(data),
        })
    updateNumberPP3ById = (data) =>
        this.authFetch({
            url: "number-pp3/updateNumberPP3ById",
            method: "POST",
            body: JSON.stringify(data),
        })
    insertNumberPP3 = (data) =>
        this.authFetch({
            url: "number-pp3/insertNumberPP3",
            method: "POST",
            body: JSON.stringify(data),
        })
    deleteNumberPP3ById = (data) =>
        this.authFetch({
            url: "number-pp3/deleteNumberPP3ById",
            method: "POST",
            body: JSON.stringify(data),
        })
}
